module.exports = __webpack_public_path__ + "img/1.67f20b78.png";